<script>
export default {
  name: 'nx-base-page',
  data() {
    return {
      pageLoaded: false,
    };
  },
  provide() {
    return {
      $wizardContext: null,
    };
  },
  methods: {
    finishLoading(data = '') {
      const currentDate = new Date();
      const loading = this.$store.getters.loading;
      const elapsedTime = currentDate.getTime() - loading.viewChangeStarts.getTime();
      const ts = (elapsedTime >= 0 && elapsedTime < loading.threshold) ? loading.threshold - elapsedTime : 0;
      setTimeout(() => {
        this.pageLoaded = true;
        this.$store.dispatch('UPDATE_LOADING_VIEW', false);
      }, ts);

      data = (typeof data === 'object') ? data : { pageName: data };
      this.$eventNotifier.Page.Loaded(data);
    },
  },
};
</script>
